export const fundInitialStatus = {
  connectWallet: {
    status: "pending",
    type: "http",
    text: "Connect Your Wallet",
    error: "Your wallet failed to connect",
    description: "Link your digital wallet to participate in crowdfunding",
    step: 0,
  },
  switchNetwork: {
    status: "pending",
    type: "contract",
    text: "Switch to Correct Network",
    error: "Failed to switch to the correct network",
    description:
      " Switch network to align your wallet with the project's specified blockchain network",
    step: 1,
    hidden: true,
  },
  prepare: {
    status: "pending",
    type: "http",
    text: "Prepare for Minting",
    error: "Failed to prepare for minting",
    description:
      "Initiating contract communication, generating NFT metadata, and storing on IPFS",
    step: 2,
  },
  approve: {
    status: "pending",
    type: "contract",
    text: "Approve Asset Allocation",
    description: "Authorize the spending cap of your asset for fundraising",
    error: "Failed to approve asset allocation",
    step: 3,
    hidden: true,
  },
  mint: {
    status: "pending",
    type: "contract",
    text: "Mint and Receive Fundraising NFT",
    description:
      "Sign the transaction to create your fundraising NFT and have it sent directly to your wallet",
    error: "Failed to mint and receive fundraising NFT",
    step: 4,
  },
};
